import texts from '@/utils/i18n/deprecationGate.json';

export type DeprecationGateTexts = typeof texts.en;

// German for a German browser or device, English for every other language.
export function getDeprecationGateTexts(
  languages: readonly string[] = navigator.languages ?? [navigator.language]
): DeprecationGateTexts {
  return languages[0]?.toLowerCase().startsWith('de') ? texts.de : texts.en;
}
